import backend from "../../mm-backend";
import {logger} from "../../main";
import {isDefined} from "../../utils";
import i18n from "../../i18n";
import themesHelper from "../themes-helper";
import localStorageHelper from "../../localstorage/local-storage";

const {t} = i18n.global;

export class ThemesStorage {

    _themes;
    _themesTabs;

    constructor() {
    }

    loadThemes() {
        return new Promise((resolve, reject) => {
            backend.getThemes().then(resp => {
                logger.log("Themes loaded");
                this._themes = resp.data;
                this.createTabsFromConfig(resp.data);
                resolve(this._themes);
            }, error => {
                reject(error);
            });
        });
    }

    addPreferredBoothTab() {
        if (!isDefined(this._themesTabs)) {
            return
        }
        const findIndex = this._themesTabs.findIndex(t => t.id === 'PREFERRED-BOOTH-TAB');
        if (findIndex !== -1) {
            return;
        }
        this._themesTabs.push(this.getPreferredBoothTab());
        this.calculateLastTab(this._themesTabs);
    }

    getPreferredBoothTab() {
        return {
            id: `PREFERRED-BOOTH-TAB`,
            categoriesInTab: [],
            selectEntriesAs: 'normal',
            sortOrder: 'A',
            title: t('mm_exhibitor_meeting_point')
        }
    }

    removePreferredBoothTab() {
        if (!isDefined(this._themesTabs)) {
            return
        }
        const findIndex = this._themesTabs.findIndex(t => t.id === 'PREFERRED-BOOTH-TAB');
        if (findIndex === -1) {
            return;
        }
        this._themesTabs.splice(findIndex, 1);
        this.calculateLastTab(this._themesTabs);
    }

    calculateLastTab(tabs) {
        for (const tab of tabs) {
            if (tab.subTabs) {
                tab.subTabs.forEach(t => t.isLastTab = false);
            }
            tab.isLastTab = false;
        }

        const lastTab = tabs[tabs.length - 1];
        if (lastTab.subTabs) {
            lastTab.subTabs[lastTab.subTabs.length - 1].isLastTab = true;
        } else {
            lastTab.isLastTab = true;
        }
    }


    createTabsFromConfig(themes, isDuringRegistration, userRole) {
        const tabs = [];
        if (themes.length === 0) {
            return tabs;
        }
        for (const theme of themes) {
            if (theme.hidden || (isDuringRegistration && theme.hidden_during_registration)) {
                continue;
            }

            if (isDefined(theme.section)) {
                // Sections
                if (tabs.find(t => t.id === `${theme.section}-TAB`)) {
                    // Once we find a section we get and insert all themes for that section.
                    // So we handle each section only once.
                    continue;
                }
                const themesInSection = themes.filter(t => t.section === theme.section);
                const tab = {
                    id: `${theme.section}-TAB`,
                    categoriesInTab: themesInSection.map(t => t.id),
                    selectEntriesAs: 'normal',
                    title: theme.section,
                    subTabs: []
                }
                for (const subTheme of themesInSection) {
                    if (this.isAvailable('common', theme, userRole)) {
                        const subTab = {
                            id: `${subTheme.id}-TAB`,
                            selectEntriesAs: 'normal',
                            categoriesInTab: [subTheme.id],
                            title: subTheme.title,
                        }
                        tab.subTabs.push(subTab);
                    }
                }
                tabs.push(tab);
            } else if (isDefined(theme['question.offer']) && isDefined(theme['question.search'])) {
                // Search and Offer
                if (tabs.find(t => t.id === themesHelper.getOfferTabId() || t.id === themesHelper.getSearchTabId())) {
                    // Once we find the first theme with search and offer
                    // we insert the offer and search tabs with all the themes in them.
                    continue;
                }
                const searchAndOfferThemes = themes.filter(t => isDefined(t['question.offer']) && isDefined(t['question.search']));
                const offerTab = {
                    id: themesHelper.getOfferTabId(),
                    selectEntriesAs: 'offer',
                    categoriesInTab: [],
                    subTabs: [],
                    title: t(`${themesHelper.getOfferTabId()}-header`),
                }
                const searchTab = {
                    id: themesHelper.getSearchTabId(),
                    selectEntriesAs: 'search',
                    categoriesInTab: [],
                    subTabs: [],
                    title: t(`${themesHelper.getSearchTabId()}-header`),
                }
                for (const theme of searchAndOfferThemes) {
                    if (this.isAvailable('offer', theme, userRole)) {
                        const tabForOffer = {
                            id: `${theme.id}-TAB-OFFER`,
                            selectEntriesAs: 'offer',
                            categoriesInTab: [theme.id],
                            title: theme.title,
                        }
                        offerTab.subTabs.push(tabForOffer);
                        offerTab.categoriesInTab.push(theme.id);
                    }
                    if (this.isAvailable('search', theme, userRole)) {
                        const tabForSearch = {
                            id: `${theme.id}-TAB-SEARCH`,
                            selectEntriesAs: 'search',
                            categoriesInTab: [theme.id],
                            title: theme.title,
                        }
                        searchTab.subTabs.push(tabForSearch);
                        searchTab.categoriesInTab.push(theme.id);
                    }
                }
                tabs.push(offerTab);
                tabs.push(searchTab);
            } else {
                // Normal
                const tab = {
                    id: `${theme.id}-TAB`,
                    categoriesInTab: [theme.id],
                    selectEntriesAs: 'normal',
                    sortOrder: theme.sortOrder,
                    title: theme.title
                }
                tabs.push(tab);
            }
        }
        const user = localStorageHelper.getUser();
        if (isDefined(user) && isDefined(user.role) && user.role === process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE) {
            tabs.push(this.getPreferredBoothTab());
        }else {
            if (isDefined(process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE_ROOT) &&
                isDefined(process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE)) {
                const roleTheme = themes.find(t => t.id === process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE_ROOT)
                const user = localStorageHelper.getUser();
                if (isDefined(roleTheme)) {
                    if (isDefined(user) && isDefined(user.themes)) {
                        const selectedValue = user.themes[process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE_ROOT];
                        if (isDefined(selectedValue)) {
                            if (Array.isArray(selectedValue)) {
                                if (selectedValue.find(t => t === process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE)) {
                                    tabs.push(this.getPreferredBoothTab());
                                }
                            }
                        }
                    }
                }
            }
        }

        this.calculateLastTab(tabs);
        this._themesTabs = tabs;
    }


    get themes() {
        return this._themes;
    }

    isAvailable(type, theme, userRole) {
        return true;
    }
}
